import React from 'react';
import { Typography, Alert } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import type { AutofacturaRestaurantInfo } from '../../types/autofactura';

const { Title, Text } = Typography;

interface AutofacturaHeaderProps {
  restaurant: AutofacturaRestaurantInfo;
}

const AutofacturaHeader: React.FC<AutofacturaHeaderProps> = ({ restaurant }) => {
  return (
    <div style={{ textAlign: 'center', marginBottom: 24 }}>
      {restaurant.logoBase64 && restaurant.logoMimeType && (
        <img
          src={`data:${restaurant.logoMimeType};base64,${restaurant.logoBase64}`}
          alt={restaurant.name}
          style={{
            maxHeight: 80,
            maxWidth: 200,
            marginBottom: 12,
            objectFit: 'contain',
          }}
        />
      )}
      <Title level={4} style={{ margin: 0 }}>
        {restaurant.name}
      </Title>
      <Text type="secondary">Portal de Autofacturación</Text>
      <Alert
        type="info"
        showIcon
        icon={<InfoCircleOutlined />}
        message={`¿Tienes problemas para facturar o necesitas ayuda? Contacta directamente a ${restaurant.name}.`}
        style={{ marginTop: 16, textAlign: 'left' }}
      />
    </div>
  );
};

export default AutofacturaHeader;
